/**
 * Returns the privacy policy ID for the given locale
 * @param {string} locale - The locale code (it, en, fr, de)
 * @returns {number} The privacy policy ID for the specified locale
 */
export const getPrivacyPolicyId = (locale) => {
  const privacyPolicyIds = {
    it: 34811234,
    en: 59424743,
    fr: 86946756,
    de: 22062360,
  }
  
  return privacyPolicyIds[locale] || privacyPolicyIds.en // Default to English if locale not found
} 